/*
  «Удалить счёт» в шапке карточки - решение владельца 16.10.2026.

  Окно то же, что у реестра: оно само спросит сервер, можно ли удалить этот
  счёт, и откажет с причиной, если по нему уже идёт дело. После удаления
  карточки больше нет, поэтому человек уходит в реестр, и итог встречает его
  там.
*/

import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AccountsRemoveDialog from './AccountsRemoveDialog.jsx'

export default function AccountRemoveButton({ card, profile }) {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  // Перечень один на всё время окна: окно перечитывает разбор, когда он меняется.
  const chosen = useMemo(
    () => [{ account_id: card.account_id, number: card.number }],
    [card.account_id, card.number],
  )
  if (!profile.permissions.includes('delete_accounts')) return null

  function removed(result) {
    setOpen(false)
    if (result.removable.length === 0) return
    navigate('/registry', {
      state: { notice: { kind: 'ok', text: `Счёт № ${card.number} удалён.` } },
    })
  }

  return (
    <>
      <button
        type="button"
        className="button button--quiet button--danger-quiet"
        disabled={Boolean(profile.is_readonly)}
        onClick={() => setOpen(true)}
      >
        Удалить счёт
      </button>
      {open ? (
        <AccountsRemoveDialog chosen={chosen} onClose={() => setOpen(false)} onRemoved={removed} />
      ) : null}
    </>
  )
}
